export const classnames = (classes: Record<string, boolean>): string => {
  return Object.entries(classes).reduce(
    (accumulator: string, [currentClass, bool]) =>
      accumulator + (bool ? `${currentClass} ` : ''),
    '',
  );
};
